'use client';

import { useEffect, useRef } from 'react';
import { safePostHogCapture } from 'utils/posthogHelpers';

const BuilderFallbackTracker = ({ slug, reason }) => {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;
    safePostHogCapture('builder_content_fallback', {
      offering_slug: slug,
      fallback_reason: reason,
    });
  }, [slug, reason]);

  return null;
};

export default BuilderFallbackTracker;
